export default [{
  path: '/dashboard',
  name: 'dashboard',
  component: () => import('./Dashboard'),
  meta: {
    resource: 'dashboard',
    actions: ['read']
  }
}]
